
let currencyrate = Shopify.currency.rate;

if(window.innerWidth > 768)
{
  

let search_bar = document.querySelector('.header__search details');
if (search_bar) {
  search_bar.addEventListener('toggle', () => {
    let autocomplete = document.querySelector('.wizzy-autocomplete-wrapper');
    if(autocomplete && getComputedStyle(autocomplete).display === "flex")
    {
      if (!search_bar.open) {
      // User closed it (including via Escape)
      // console.log('Details was closed. Re-opening it!');
      search_bar.open = true;
      }
    }
    
  });
}
}
let search_bar_1 = document.querySelector(
  '.search-modal__content_drawer_new .wizzy-search-input, .search-modal__content_drawer_new .search__input.field__input'
);

// console.log(search_bar_1);

function attachSuggestionClickListeners() {
  // console.log("Attaching listeners to autocomplete-text-wrapper");

  setTimeout(() => {
    document.querySelectorAll('.autocomplete-text-wrapper').forEach(function(wrapper) {
      wrapper.addEventListener('click', function(event) {
        search_bar_1.click();
        search_bar_1.value = wrapper.parentElement.getAttribute("data-searchterm");
        // search_bar_1.dispatchEvent(new Event('input', { bubbles: true }));
        // console.log('Set search input to:', text);
      });
    });
  }, 500);
}

if (search_bar_1) {
  search_bar_1.addEventListener("click", function() {
    // console.log("clicked on search bar");
    attachSuggestionClickListeners();
  });

  search_bar_1.addEventListener("input", function() {
    // console.log("typed in search bar");
    attachSuggestionClickListeners();
  });
}
const searchBar = document.querySelector(".search-modal__content_drawer_new .search__input.field__input");
if(searchBar)
{
  searchBar.addEventListener("click", () => {
    setTimeout( () => {
      // console.log("Searchbar is clicked now");
        let autoCompleteArrows = document.querySelectorAll(".autocomplete-text-wrapper");
        if(autoCompleteArrows){
          // console.log("Inside if condition arrow");
          autoCompleteArrows.forEach((arrow) => {
            if(arrow)
            {
              arrow.addEventListener("click", () => {
                searchBar.value = arrow.parentElement.getAttribute("data-searchterm");
                searchBar.focus();
                // console.log(arrow.parentElement.getAttribute("data-searchterm"));
            });
            }
          });
        }
    }, 300)
}
);
}

window.onWizzyScriptLoaded = function () {
  if(window.wizzyConfig?.store?.currency?.code && window.wizzyConfig?.store.currency.symbol)
  {
    let code = window.wizzyConfig.store.currency.code;
    let symbol = window.wizzyConfig.store.currency.symbol;
    if(code === symbol)
    {
      document.body.classList.add('wz-same-currency');
    }
  }
  const targetNode = document.querySelector(".wizzy-body-end-wrapper");
  function updateBodyClass() {
      const autocompleteElement = targetNode.querySelector(".wizzy-autocomplete-wrapper");
      autocompleteElement && window.getComputedStyle(autocompleteElement).display === "flex" ? document.body.classList.add("wizzy-autocomplete-open") : document.body.classList.remove("wizzy-autocomplete-open")
      if(autocompleteElement)
      {
        const heads = document.querySelectorAll('.autocomplete-item-head');

        heads.forEach(head => {
          // get only the text part (ignores <a>)
          const textOnly = Array.from(head.childNodes)
            .filter(node => node.nodeType === Node.TEXT_NODE) // only text nodes
            .map(node => node.textContent.trim())
            .join(' ')
            .trim();

          if (textOnly === "Recent Searches") {
            let next = head.nextElementSibling;
            let count = 0;

            while (next && !next.classList.contains('autocomplete-item-head')) {
              if (next.classList.contains('autocomplete-item')) {
                count++;
                if (count > 5) {
                  next.remove();
                }
              }
              next = next.nextElementSibling;
            }
          }
        });
      }
  }
  const config = {
      childList: !0,
      subtree: !0,
      attributes: !0,
      attributeFilter: ["style"]
  }
    , callback = function(mutationsList, observer2) {
      for (const mutation of mutationsList) {
          updateBodyClass();
          break
      }
  }
    , observer = new MutationObserver(callback);
  targetNode && (observer.observe(targetNode, config),
  updateBodyClass());

$("body").on("change", ".wizzy-range-for-grid", function (event) {
  handleRangeInputValueChange(event.target.value);
});
function handleRangeInputValueChange(value) {
    let x = document.querySelector(".wizzy-search-results");
    if (typeof x != "undefined") {
      if (x.classList.contains("wizzy-2-products-in-a-row")) {
        x.classList.remove("wizzy-2-products-in-a-row");
      }

      if (x.classList.contains("wizzy-4-products-in-a-row")) {
        x.classList.remove("wizzy-4-products-in-a-row");
      }

      if (x.classList.contains("wizzy-6-products-in-a-row")) {
        x.classList.remove("wizzy-6-products-in-a-row");
      }

      sessionStorage.setItem("wizzy-2-products-in-a-row", false);
      sessionStorage.setItem("wizzy-4-products-in-a-row", false);
      sessionStorage.setItem("wizzy-6-products-in-a-row", false);
      x.classList.add("wizzy-" + value + "-products-in-a-row");
      sessionStorage.setItem("wizzy-" + value + "-products-in-a-row", true);
    }
  }
function toHandleComingBackFromProductPage() {
    let waitForInputToLoad = setInterval(function () {
      let CBrangeInputForGrid = document.querySelector(".wizzy-range-for-grid");
      if (CBrangeInputForGrid != null && CBrangeInputForGrid != undefined) {
        if (sessionStorage.getItem("wizzy-2-products-in-a-row") === "true") {
          CBrangeInputForGrid.value = 2;
          handleRangeInputValueChange(2);
        } else if (
          sessionStorage.getItem("wizzy-4-products-in-a-row") === "true"
        ) {
          CBrangeInputForGrid.value = 4;
          handleRangeInputValueChange(4);
        } else if (
          sessionStorage.getItem("wizzy-6-products-in-a-row") === "true"
        ) {
          CBrangeInputForGrid.value = 6;
          handleRangeInputValueChange(6);
        }
        clearInterval(waitForInputToLoad);
      }
    }, 1000);

    setTimeout(function () {
      clearInterval(waitForInputToLoad);
    }, 10000);
  }

toHandleComingBackFromProductPage();
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_RESULTS_RENDERED,
    function (payload) {
        let rangeInputForGrid;
      if (window.innerWidth <= 768) {
        rangeInputForGrid = document.querySelectorAll(
          ".wizzy-range-for-grid"
        )[1];
      } else {
        rangeInputForGrid = document.querySelectorAll(
          ".wizzy-range-for-grid"
        )[0];
      }
      if (
        sessionStorage.getItem("wizzy-2-products-in-a-row") === "true" &&
        rangeInputForGrid != null &&
        typeof rangeInputForGrid != "undefined"
      ) {
        // console.log("2 products in a row");
        rangeInputForGrid.value = 2;
        handleRangeInputValueChange(2);
      } else if (
        sessionStorage.getItem("wizzy-4-products-in-a-row") === "true" &&
        rangeInputForGrid != null &&
        typeof rangeInputForGrid != "undefined"
      ) {
        // console.log("3 products in a row");
        rangeInputForGrid.value = 4;
        handleRangeInputValueChange(4);
      } else if (
        sessionStorage.getItem("wizzy-6-products-in-a-row") === "true" &&
        rangeInputForGrid != null &&
        typeof rangeInputForGrid != "undefined"
      ) {
        // console.log("4 products in a row");
        rangeInputForGrid.value = 6;
        handleRangeInputValueChange(6);
      }

      return payload;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (data) {
      
      data.search.configs.general.minQueryLength = 1;
      window.wizzyConfig.search.configs.facets.showPriceInputRangeFields = true;
      data.filters.configs.keepOpenedInMobileAfterApply = true;
      window.wizzyConfig.search.configs.pagination.infiniteScrollOffset = {
        desktop: 5e3,
        mobile: 5e3,
      };
      try {
        window.wizzyConfig.search.view.templates.facets.rangeListItem =
          "#wizzy-facet-range-list-item";
        data.search.configs.facets.configs = data.search.configs.facets.configs.map((obj) => {
          if (obj.key === "sellingPrice") {
            obj.buckets = [
            {
              from: 0,
              to: 300,
            },
            {
              from: 300,
              to: 700,
            },
            {
              from: 700,
              to: 1500,
            },
            {
              from: 1500,
              to: 3500,
            },
            {
              from: 3500,
              to: 6000,
            },
          ];
          }
          return obj;
        });
      } catch (error) {}

      return data;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
    function (data) {
       data.search.configs.general.minQueryLength = 1;
       window.wizzyConfig.search.configs.facets.showPriceInputRangeFields = true;
      window.wizzyConfig.search.configs.pagination.infiniteScrollOffset = {
        desktop: 5e3,
        mobile: 5e3,
      };
      data.filters.configs.keepOpenedInMobileAfterApply = true;
      try {
        window.wizzyConfig.search.view.templates.facets.rangeListItem =
          "#wizzy-facet-range-list-item";
        data.search.configs.facets.configs = data.search.configs.facets.configs.map((obj) => {
          if (obj.key === "sellingPrice") {
            obj.buckets = [
            {
              from: 0,
              to: 300,
            },
            {
              from: 300,
              to: 700,
            },
            {
              from: 700,
              to: 1500,
            },
            {
              from: 1500,
              to: 3500,
            },
            {
              from: 3500,
              to: 6000,
            },
          ];
          }
          return obj;
        });
      } catch (error) {}

      return data;
    }
  );
  const colorMap = new Map([
    [
      "Multi",
      [
        "https://cdn.shopify.com/s/files/1/0636/0134/4666/files/multicolor_filter_01dd6091-6aa8-4887-97bf-1a50e81100a5.png?v=1747300683",
        !0,
      ],
    ],
    ["Brown", ["#964B00", !1]],
    ["Red", ["#FF0000", !1]],
    ["Orange", ["#FFA500", !1]],
    ["Yellow", ["#FFFF00", !1]],
    ["Green", ["#00FF00", !1]],
    ["Blue", ["#0000FF", !1]],
    ["Beige", ["#F5F5DC", !1]],
    ["Pink", ["#FFC0CB", !1]],
    ["Peach", ["#FFE5B4", !1]],
    ["Purple", ["#800080", !1]],
    ["Gold", ["#FFD700", !1]],
    ["Black", ["#000000", !1]],
    ["Grey", ["#808080", !1]],
    ["White", ["#FFFFFF", !1]],
    ["Wine", ["#990012", !1]],
    ["Silver", ["#C0C0C0", !1]],
    ["Off White", ["#F8F0E3", !1]],
    
  ]);
  function findHaxCode(key) {
    return colorMap.has(key) ? colorMap.get(key) : [key, !1];
  }
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
    function (payload) {
      // console.log("BEFORE_RENDER_RESULTS", payload);
      if(payload.response.payload.hasToRedirect === true)
      {
        window.location.href = payload.response.payload.redirectTo;        
      }
      if (payload.api === "search" || payload.api === "filter") {
        var facets = payload.response.payload.facets;
        facets.forEach((facet) => {
          facet.key === "product_confi_color_magento" &&
            facet.data.forEach((item) => {
              let color = findHaxCode(item.key);
              (item.isSwatch = !0),
                (item.isURLSwatch = color[1]),
                (item.isVisualSwatch = !0),
                (item.swatchValue = color[0]),
                (item.data = {
                  value: item.key,
                  swatch: {
                    type: "visual",
                    value: color[0],
                  },
                });
            });
        });
      }

      facets = payload.response.payload.facets;
      for (let i = 0; i < facets.length; i++) {
        if (facets[i].key == "sizes") {
          let sizes = facets[i].data,
            numbers = [],
            letters = [],
            newArray = new Array(),
            temp = [
              "US 0",
              "US 2",
              "US 4",
              "US 6",
              "US 8",
              "US 10",
              "US 12",
              "US 14",
              "US 16",
              "US 17",
              "US 18",
              "US 19",
              "US 20",
              "US 21",
              "S",
              "M",
              "36",
              "38",
              "40",
              "42",
              "44",
              "46",
              "48",
              "50",
              "Fabric Only",
            ];
          for (let j = 0; j < temp.length; j++) {
            for (let k = 0; k < sizes.length; k++) {
              sizes[k].key == temp[j] && newArray.push(sizes[k]);
            }
          }
          facets[i].data = newArray;
        }
      }

      return payload;
    }
  );
  function getGumletUrl(src, params = {}, settings = {}) {
  if (!src) return '';

  // 1️⃣ Default settings (can be overridden)
  const defaults = {
    enableGumlet: true,
    gumletUrl: 'https://global-kalki.gumlet.io', // your Gumlet domain
    gumletShopifyCdnUrl: 'cdn.shopify.com', // Shopify CDN base
  };

  const cfg = { ...defaults, ...settings };

  // 2️⃣ If Gumlet disabled or missing required info → return original URL
  if (!cfg.enableGumlet || !cfg.gumletUrl || !src.includes(cfg.gumletShopifyCdnUrl)) {
    return src;
  }

  // 3️⃣ Remove any ?v= version parameter (optional cleanup)
  let baseSrc = src.split('?v=')[0];

  // 4️⃣ Replace Shopify CDN domain with Gumlet domain + correct path
  baseSrc = baseSrc.replace(/^https?:\/\/cdn\.shopify\.com\/s\//, `${cfg.gumletUrl}/cdn/shop/`);

  // 5️⃣ List of all allowed Gumlet filters (based on your Liquid snippet)
  const allowedFilters = [
    'bri','con','cs','exp','gam','high','hue','invert','sat','shad','sharp','usm','usmrad','vib','auto','bg',
    'blend','bm','ba','balph','bp','bw','bh','bf','bc','bs','bx','by','border','pad','faceindex','facepad',
    'faces','ch','chromasub','colorquant','dl','dpi','fm','lossless','q','mask','nr','nrs','colors','palette',
    'prefix','dpr','flip','or','rot','crop','fit','h','rect','w','blur','htn','mono','px','sepia','txt',
    'txtalign','txtclip','txtclr','txtfit','txtfont','txtline','txtlineclr','txtpad','txtshad','txtsize',
    'txtwidth','trim','trimcolor','trimmd','trimpad','trimsd','trimtol','mark','markalign','markalpha',
    'markbase','markfit','markh','markpad','markscale','markw','markx','marky'
  ];

  // 6️⃣ Build query parameters (only include recognized filters)
  const queryParams = new URLSearchParams();

  // Default param like Liquid snippet behavior
  queryParams.set('format', 'auto');

  for (const key in params) {
    if (allowedFilters.includes(key) && params[key] !== undefined && params[key] !== null && params[key] !== '') {
      queryParams.set(key, params[key]);
    }
  }

  // 7️⃣ Build final Gumlet URL
  const gumletUrl = `${baseSrc}?${queryParams.toString()}`;

  return gumletUrl;
}



  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (products) {
      if(products && products.length == 1)
      {
        document.body.classList.add('wz-one-product');
      }
      else{
        document.body.classList.remove('wz-one-product');
      }
      

      try {
        const removeId = 52657557668113;
        const index = products.findIndex(p => p.id === removeId);
        if (index !== -1) {
          products.splice(index, 1);
        }
        products.forEach((product) => {
          // console.log(product.id);
          // if (product.id === 52657557668113) {
          //     products.splice(i, 1);
          //     continue;
          // }
          const transformedName = product.name
            .toLowerCase()
            .replace(/\s+/g, "-");
          
          product.productHandle = transformedName;
          const url = new URL(product.url);
          url.searchParams.delete("variant");
          product.url = url.toString();
          if(!product.formatted_price)
          {
            try {
              // console.log("inside formatted price");
              let product_sellingprice = product.sellingPrice;
              product_sellingprice = product.sellingPrice.toString().replace(/,/g, '');
              product_sellingprice = parseFloat(product_sellingprice) || 0;
              product.sellingPrice = product_sellingprice;
              product.sellingPrice = product.sellingPrice * currencyrate;
              product.sellingPrice = Math.ceil(product.sellingPrice);
              if(product.price)
              {
                product.price = product.price?.toString().replace(/,/g, '');
                product.price = parseFloat(product.price) || 0;
                product.price = product.price * currencyrate;
                product.price = Math.ceil(product.price);
                
              } 
              product.formatted_price = true;
              // console.log("sellingPrice", product.sellingPrice);
            } catch (error) {
              console.log(error);
            }
          }
          

          const deliveryMeta = product.attributes.find(
            (item) => item.id === "product_filter_delivery_custom"
          );
          if (deliveryMeta) {
            let del = deliveryMeta.values[0].value[0];
            if (del == "Ready To Ship") {
              product.deliveryMeta = del;
            } else {
              product.deliverydayMeta = del;
            }
          }

          const festivalMeta = product.attributes.find(
            (item) => item.id === "product_festival_stamp_magento"
          );

          if (festivalMeta || deliveryMeta) {
            product.hasLabel = true;
          }
          if (festivalMeta) {
            product.festivalMeta = festivalMeta.values[0].value[0];
          }
          // let new_images = [];
          // if(product.images)
          // {
          //   product.images.forEach((img) => {
          //     new_images.push(getGumletUrl(img));
          //   });
          //   product.images = new_images;
          // }
          
        });
      } catch (error) {}

      return products;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_WIZZY_API_RESPONDED,
    function (data) {
      // console.log("AFTER_WIZZY_API_RESPONDED", data);
      // if(window.webengage)
      try {
        if (data.api === "search") {
            const totalCount = data?.response?.payload?.total;
            const query = data?.response?.payload?.filters?.q;
            // console.log("webengage",window.webengage);
            if (typeof totalCount === "number" && query && window.webengage) {
                window.webengage.track("Searched Product" , {
                "Source" : "Shopify",
                "Terms" : query,
                "Total Items" : totalCount
              })
              window.dataLayer = window.dataLayer || [];

              dataLayer.push([
                "event",
                "search",
                {
                  search_term: query
                }
              ]);
              // console.log("Query : ",query , typeof query);
              // console.log("totalCount : ",totalCount , typeof totalCount);
          }          
        }
      } catch (error) {
        console.log(error);
      }
      
      return data;
    });

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (data) {
      let body = document.body;
      if(window.wizzyConfig?.store?.currency?.code && window.wizzyConfig?.store?.currency?.symbol)
      {
        let code = window.wizzyConfig.store.currency.code;
        let symbol = window.wizzyConfig.store.currency.symbol;
        if(code === symbol)
        {
          document.body.classList.add('wz-same-currency');
        }
      }
      document.body.classList.remove('template-collection');
      document.body.classList.remove('collection_hide_announcement_bar_new');
      document.body.classList.remove('collection_full_width_new');
      document.body.classList.remove('template-product');
      document.body.classList.remove('template--bridal');
      document.body.classList.remove('collection_header_transparent_new');
      if (body.classList.contains("template--bridal-collection-new")) {
        body.classList.remove("template--bridal-collection-new");
      }
      if (body.classList.contains("template--luxe-collection-new")) {
        body.classList.remove("template--luxe-collection-new");
      }
      if (body.classList.contains("bridal-wedding-dresses_page_new")) {
        body.classList.remove("bridal-wedding-dresses_page_new");
      }
      if (body.classList.contains("template--bridal-wedding-dress-new")) {
        body.classList.remove("template--bridal-wedding-dress-new");
      }
      if (body.classList.contains("page_white_header_transparent_new")) {
        body.classList.remove("page_white_header_transparent_new");
      }
      if (
        body.classList.contains("collection_hide_announcement_bar_new") &&
        body.classList.contains("collection_header_transparent_new")
      ) {
        // console.log("inside removing");
        body.classList.remove(
          "collection_hide_announcement_bar_new",
          "collection_header_transparent_new"
        );
      }

      let video = document.querySelector(".Collection_meta_banner_new");
      if (video) video.style.setProperty("display", "none", "important");

      if (window.innerWidth <= 768) {
        if (body.classList.contains("template-collection")) {
          body.classList.remove("template-collection");
        }
        if (body.classList.contains("template--luxe-collection-new")) {
          body.classList.remove("template--luxe-collection-new");
        }

        if (body.classList.contains("collection_hide_announcement_bar_new")) {
          body.classList.remove("collection_hide_announcement_bar_new");
        }

        if (body.classList.contains("collection_header_transparent_new")) {
          body.classList.remove("collection_header_transparent_new");
        }

        if (body.classList.contains("collection_full_width_new")) {
          body.classList.remove("collection_full_width_new");
        }
      }

      if(data.facets)
      {
        data.facets.forEach((facet) => {
          if(facet.key === "sellingPrice") {
            facet.buckets = [
                { from: 0, to: 300 },
                { from: 300, to: 700 },
                { from: 700, to: 1500 },
                { from: 1500, to: 3500 },
                { from: 3500, to: 6000 },
              ];
          }
        })
      }

      return data;
    },3
  );

  function getWizzyCurrencyCode() {
    return window.wizzyConfig?.store?.currency?.code
      || window.Shopify?.currency?.active
      || '';
  }

  function shouldShowWizzyCurrencyCode() {
    const code = getWizzyCurrencyCode();
    const symbol = window.wizzyConfig?.store?.currency?.symbol || '';
    return Boolean(code && code !== symbol);
  }

  function convertWizzyFacetPrices() {

    let symbol = wizzyConfig?.store?.currency?.symbol || '';
    let rate = window?.Shopify?.currency?.rate || 1;

    const labels = document.querySelectorAll(
      '.wizzy-facet-body.facet-body-sellingPrice .wizzy-facet-range-list-label'
    );

    labels.forEach((label) => {

      if (label) {
        label.childNodes.forEach((node) => {
          if (node.nodeType === 3) {
            let text = node.nodeValue.trim();

            if (text) {

              if (!node.originalValue) {
                node.originalValue = text;
              }

              let original = node.originalValue;

              // let numeric = parseFloat(original.replace(/[^\d.]/g, ''));
              let numeric = parseFloat(original.replace(/[^\d]/g, ''));

              if (!isNaN(numeric)) {

                let converted = Math.round(numeric * rate);
                let converted1 = numeric * rate;
                converted = converted.toLocaleString();
                // console.log("price", numeric, converted);
                // console.log("price 1", numeric, converted1);

                node.nodeValue = ` ${symbol}${converted} `;
              }
            }
          }
        });
      }
    });

     convertWizzyAppliedPriceFilters();
  }

    let wizzySellingPriceFilterSource = "bucket";

  function markWizzyPriceFilterFromInput() {
    wizzySellingPriceFilterSource = "input";
  }

  function markWizzyPriceFilterFromBucket() {
    wizzySellingPriceFilterSource = "bucket";
  }

  window.addEventListener(
    "keydown",
    function (e) {
      if (e.key !== "Enter" && e.keyCode !== 13) return;
      const target = e.target;
      if (!target || !target.classList) return;
      if (
        target.classList.contains("wizzy-price-range-input") ||
        target.classList.contains("wizzy-range-min") ||
        target.classList.contains("wizzy-range-max") ||
        target.getAttribute("data-wizzy-range") === "min" ||
        target.getAttribute("data-wizzy-range") === "max"
      ) {
        markWizzyPriceFilterFromInput();
      }
    },
    true
  );

  window.addEventListener(
    "submit",
    function (e) {
      if (e.target && e.target.classList && e.target.classList.contains("wizzy-price-range-form")) {
        markWizzyPriceFilterFromInput();
      }
    },
    true
  );

  $("body").on(
    "click",
    ".facet-body-sellingPrice .facet-rangeList-item:not(.wizzy-price-range-list-item)",
    markWizzyPriceFilterFromBucket
  );

  function getSelectedPriceDataTerm(priceLabelElement) {
    const listItem = priceLabelElement?.closest(
      ".wizzy-selected-facet-list-item[data-facetkey='sellingPrice']"
    );
    const dataTerm = listItem?.getAttribute("data-term");
    if (!dataTerm) return null;

    const temp = document.createElement("textarea");
    temp.innerHTML = dataTerm;
    return normalizeWizzyPriceFilterLabel(temp.value);
  }

  function normalizeWizzyPriceFilterLabel(label) {
    if (!label) return label;

    return label.replace(/(\d+(?:\.\d+)?)/g, (match) => {
      const numeric = parseFloat(match);
      if (isNaN(numeric)) return match;

      return Math.round(numeric).toLocaleString(undefined, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      });
    });
  }

  function formatWizzySelectedPriceValue(numeric, rate) {
    let converted = Math.round(numeric * rate);

    return converted.toLocaleString(undefined, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
  }

  function convertWizzyAppliedPriceFilters() {
    const selectedPrice = document.querySelectorAll(
      ".wizzy-selected-facet-list-item[data-facetkey='sellingPrice'] .facet-item-label-value"
    );
    const symbol = window.wizzyConfig?.store?.currency?.symbol || '';
    const rate = window?.Shopify?.currency?.rate || 1;
    const currencyCode = getWizzyCurrencyCode();
    const showCode = shouldShowWizzyCurrencyCode();

    selectedPrice.forEach((p) => {
      if (!p) return;

      if (wizzySellingPriceFilterSource === "input") {
        const dataTermLabel = getSelectedPriceDataTerm(p);
        if (dataTermLabel) {
          p.textContent = dataTermLabel;
          p.dataset.converted = "true";
          p.dataset.priceSource = "input";
          return;
        }
      }

      if (p.dataset.converted === "true" && p.dataset.priceSource !== "input") return;

      let price = p.textContent.replace(/\.0+\b/g, "");
      let [minPrice, maxPrice] = price.split("-");

      const convertPrice = (value) => {
        if (!value) return '';

        let numeric = parseFloat(value.replace(/[^\d.]/g, ''));

        if (!isNaN(numeric)) {
          const converted = formatWizzySelectedPriceValue(numeric, rate);
          return `${symbol}${converted}`;
        }

        return value.trim();
      };

      minPrice = convertPrice(minPrice?.trim());
      maxPrice = convertPrice(maxPrice?.trim());

      const currencySuffix = showCode
        ? ` <span class="wz-currency-code">${currencyCode}</span>`
        : '';

      p.innerHTML = `${minPrice} - ${maxPrice}${currencySuffix}`;
      p.dataset.converted = "true";
      p.dataset.priceSource = "bucket";
    });
  }
  
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (data) {
      convertWizzyFacetPrices();
      let pricestoreCodes = document.querySelectorAll('.wizzy-storeCode');
      if(pricestoreCodes)
        {
            let storeCode = ''
            if(window?.wizzyConfig?.store?.currency?.code)
            {
            storeCode = window.wizzyConfig.store.currency.code
            }
            pricestoreCodes.forEach((el) => {
            el.textContent = storeCode;
            })
        }
      let searchBar = document.querySelector('.header__search details');
      searchBar.removeAttribute("open");
      // if (!mySwiperInstance) {
        // const swiperEls = document.querySelectorAll(".mySwiper");

        // swiperEls.forEach(swiperEl => {
        //   if (!swiperEl.classList.contains("swiper-ios")) {
        //     new Swiper(swiperEl, {
        //       loop: true,
        //       slidesPerView: 1,
        //       spaceBetween: 10,
        //       navigation: {
        //         nextEl: swiperEl.querySelector(".swiper-button-next"),
        //         prevEl: swiperEl.querySelector(".swiper-button-prev")
        //       },
        //       pagination: {
        //         el: swiperEl.querySelector(".swiper-pagination"),
        //         clickable: true
        //       }
        //     });
        //   }
        // });
        const swiperEls = document.querySelectorAll(".mySwiper");

        swiperEls.forEach((swiperEl) => {

          if (!swiperEl.swiper && !swiperEl.classList.contains("swiper-ios")) {
            new Swiper(swiperEl, {
              loop: true,
              slidesPerView: 1,
              spaceBetween: 10,
              navigation: {
                nextEl: swiperEl.querySelector(".swiper-button-next"),
                prevEl: swiperEl.querySelector(".swiper-button-prev")
              },
              pagination: {
                el: swiperEl.querySelector(".swiper-pagination"),
                clickable: true
              }
            });
          } else {
            // already initialized, do nothing
          }

        });
        
    //   let selectedPrice = document.querySelectorAll(
    //     ".wizzy-selected-facet-list-item[data-facetkey='sellingPrice'] .facet-item-label-value"
    //   );
    //   let symbol = wizzyConfig?.store?.currency?.symbol || '';
    //   let rate = window?.Shopify?.currency?.rate || 1;
    //   selectedPrice.forEach((p) => {

    //     if (p) {
    //       if (p.dataset.converted !== "true") {

    //         let price = p.textContent.replace(/\.0/g, "");
    //         let [minPrice, maxPrice] = price.split("-");

    //         const convertPrice = (value) => {

    //           if (value) {
    //             let numeric = parseFloat(value.replace(/[^\d.]/g, ''));

    //             if (!isNaN(numeric)) {

    //               let converted = numeric * rate;

    //               converted = converted.toLocaleString(undefined, {
    //                 minimumFractionDigits: 0,
    //                 maximumFractionDigits: 2
    //               });

    //               return `${symbol}${converted}`;

    //             } else {
    //               return value;
    //             }

    //           } else {
    //             return '';
    //           }
    //         };

    //         minPrice = convertPrice(minPrice?.trim());
    //         maxPrice = convertPrice(maxPrice?.trim());

    //         p.textContent = `${minPrice} - ${maxPrice}`;

    //         p.dataset.converted = "true";
    //       }
    //     }

    //   });
    // for price filter
    convertWizzyAppliedPriceFilters();

      const firstFilterBlock = document.querySelector(
        ".wizzy-search-filters-left-wrapper .wizzy-facet-list-block .wizzy-filters-facet-block"
      );

      if (firstFilterBlock) {
        if (firstFilterBlock.classList.contains("first-opened")) {
          firstFilterBlock.classList.remove("collapsed");
        }
      }

      let label = document.querySelector(".wizzy-common-select-label.mobile");
      if (label) {
        label.textContent = "Sort";
      }
      if (window.innerWidth <= 769) {
        const applyButton = document.querySelector(
          ".wizzy-common-select-options.inner button.no-js-hidden.button.button--primary"
        );
        if (applyButton) {
          applyButton.addEventListener("click", function () {
            document.body.classList.remove("wizzy-overlay-opened");
            document.body.classList.remove("wizzy-common-select-body-overlay");
            const sortButton = document.querySelector(
              ".wizzy-overlay-opened.wizzy-common-select-body-overlay .wizzy-common-select-selector"
            );
            if (sortButton) {
              sortButton.click();
            }

            const container = document.querySelector(
              ".wizzy-search-wrapper .wizzy-search-results-wrapper .wizzy-search-results-container .wizzy-search-filters-top .search-filters-top-wrapper .wizzy-search-sort-wrapper .wizzy-sort-container .wizzy-common-select-wrapper .wizzy-common-select-container .wizzy-common-select-options"
            );
            container.style.setProperty("display", "none", "important");
          });
        }
      }

      const original = document.querySelector(
        ".wizzy-filters-facet-block.facet-block-sizes"
      );

      if (original) {
        const targetContainer = document.querySelector(
          ".wizzy-search-filters-top .search-filters-top-wrapper .wizzy-search-filters-list-top"
        );

        if (targetContainer) {
          const existingClone = targetContainer.querySelector(
            ".wizzy-filters-facet-block.facet-block-sizes.facet-block-top"
          );

          if (!existingClone) {
            const clone = original.cloneNode(true); // true for deep clone
            clone.classList.remove("facet-block-left", "collapsed");
            clone.classList.add("facet-block-top");

            targetContainer.appendChild(clone);
          }
        }
      }
      var filterPanel = document.querySelectorAll(
        ".wizzy-search-wrapper .wizzy-search-filters-left .wizzy-filters-facet-block .wizzy-facet-head"
      );

      filterPanel.forEach((facet) => {
        facet.addEventListener("click", function (e) {
          let currentFilter = this.closest(".wizzy-filters-facet-block");
          const isActive = currentFilter.classList.contains("collapsed");

          setTimeout(() => {
            filterPanel.forEach((h) => {
              let filter = h.closest(".wizzy-filters-facet-block");
              if (filter !== currentFilter) {
                filter.classList.add("collapsed");
              }
            });

            if (isActive) {
              currentFilter.classList.remove("collapsed");
            } else {
              currentFilter.classList.add("collapsed");
            }
          }, 100);
        });
      });
      // console.log("in view rendered");
      let ranges = document.querySelectorAll(
        ".wizzy-facet-list-item.facet-rangeList-item .wizzy-facet-list-item-count"
      );
      ranges.forEach((range) => {
        if (range.textContent.trim() === "(0)") {
          range.parentElement.remove(); 
        }
      });

      const selectedList = document.querySelector(".wizzy-selected-facet-list");
      const targetDiv1 = document.querySelector(".wizzy-facet-list-block"); 
      const targetDiv2 = document.querySelectorAll(".wizzy-facet-body"); 
      let title = document.querySelector(".applied-filters-header");
      if (selectedList && selectedList.querySelectorAll("li").length > 0) {
        // console.log("Inside divs");
        targetDiv1?.classList.add("with-selected-filters");
        targetDiv2.forEach((d) => {
          d?.classList.add("with-selected-filters");
        });
        title?.classList.remove("remove");
      } else {
        // console.log("inside remove");
        // console.log("No selected filters");
        targetDiv1?.classList.remove("with-selected-filters");
        targetDiv2.forEach((d) => {
          d?.classList.remove("with-selected-filters");
        });
        // console.log(title);
        title?.classList.add("remove");
        // console.log("Removed title", title);
      }
      document
        .querySelectorAll(".wizzy-grid-filters-box")
        .forEach((filterBox) => {
          const facetList = filterBox.querySelector(".wizzy-facet-list");
          const leftButton = filterBox.querySelector(".scroll-btn.left");
          const rightButton = filterBox.querySelector(".scroll-btn.right");

          if (!facetList || !leftButton || !rightButton) return;

          leftButton.addEventListener("click", () => {
            facetList.scrollBy({ left: -200, behavior: "smooth" });
          });

          rightButton.addEventListener("click", () => {
            facetList.scrollBy({ left: 200, behavior: "smooth" });
          });
        });

      const priceElements = document.querySelectorAll('.price-item--regular');
      priceElements.forEach((el) => {
        el.textContent = el.textContent.replace(/\.00\b/, '');
      });

      document.addEventListener("click", function (e) {
        if (
          !e.target.closest(
            ".filters-list-top-values-wrapper .wizzy-facet-body"
          ) &&
          !e.target.closest(".wizzy-search-filters-list-top .wizzy-facet-head")
        ) {
          const wrapper = document.querySelector(
            ".filters-list-top-values-wrapper"
          );
          let facets = document.querySelectorAll(
            ".wizzy-search-filters-list-top .wizzy-filters-facet-block"
          );

          facets.forEach((facet) => {
            let head = facet.querySelector(".wizzy-facet-head");
            if (head && head.classList.contains("active")) {
              head.classList.remove("active");
              if (wrapper) {
                const childDivs = wrapper.querySelectorAll("div");
                childDivs.forEach((div) => div.remove());
              }
            }
          });
        }
      });

      return data;
    }
  );
window.wizzyConfig.events.registerEvent(
  window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
  function (payload) {
    if (payload.filters) {
      payload.filters.showOOSProductsInOrder = "true";
    }

    if(window.wizzyConfig?.store?.currency?.code && window.wizzyConfig?.store?.currency?.symbol)
    {
      let code = window.wizzyConfig.store.currency.code;
      let symbol = window.wizzyConfig.store.currency.symbol;
      if(code === symbol)
      {
        document.body.classList.add('wz-same-currency');
      }
    }

    return payload;
  }
);
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
    function (data) {
        let pricestoreCodes = document.querySelectorAll('.wizzy-storeCode');
      if(pricestoreCodes)
        {
            let storeCode = ''
            if(window?.wizzyConfig?.store?.currency?.code)
            {
            storeCode = window.wizzyConfig.store.currency.code
            }
            pricestoreCodes.forEach((el) => {
            el.textContent = storeCode;
            })
        }
      toHandleComingBackFromProductPage();
      convertWizzyFacetPrices();
    //   let selectedPrice = document.querySelectorAll(
    //     ".wizzy-selected-facet-list-item[data-facetkey='sellingPrice'] .facet-item-label-value"
    //   );
    //   let symbol = wizzyConfig?.store?.currency?.symbol || '';
    //   let rate = window?.Shopify?.currency?.rate || 1;
    //   selectedPrice.forEach((p) => {

    //     if (p) {
    //       if (p.dataset.converted !== "true") {

    //         let price = p.textContent.replace(/\.0/g, "");
    //         let [minPrice, maxPrice] = price.split("-");

    //         const convertPrice = (value) => {

    //           if (value) {
    //             let numeric = parseFloat(value.replace(/[^\d.]/g, ''));

    //             if (!isNaN(numeric)) {

    //               let converted = numeric * rate;

    //               converted = converted.toLocaleString(undefined, {
    //                 minimumFractionDigits: 0,
    //                 maximumFractionDigits: 2
    //               });

    //               return `${symbol}${converted}`;

    //             } else {
    //               return value;
    //             }

    //           } else {
    //             return '';
    //           }
    //         };

    //         minPrice = convertPrice(minPrice?.trim());
    //         maxPrice = convertPrice(maxPrice?.trim());

    //         p.textContent = `${minPrice} - ${maxPrice}`;

    //         p.dataset.converted = "true";
    //       }
    //     }

    //   });
    // for price filter
        convertWizzyAppliedPriceFilters();

      const firstFilterBlock = document.querySelector(
        ".wizzy-search-filters-left-wrapper .wizzy-facet-list-block .wizzy-filters-facet-block"
      );

      if (firstFilterBlock) {
        if (firstFilterBlock.classList.contains("first-opened")) {
          firstFilterBlock.classList.remove("collapsed");
        }
      }

      let label = document.querySelector(".wizzy-common-select-label.mobile");
      if (label) {
        label.textContent = "Sort";
      }
      if (window.innerWidth <= 769) {
        const applyButton = document.querySelector(
          ".wizzy-common-select-options.inner button.no-js-hidden.button.button--primary"
        );
        if (applyButton) {
          applyButton.addEventListener("click", function () {
            document.body.classList.remove("wizzy-overlay-opened");
            document.body.classList.remove("wizzy-common-select-body-overlay");
            const sortButton = document.querySelector(
              ".wizzy-overlay-opened.wizzy-common-select-body-overlay .wizzy-common-select-selector"
            );
            if (sortButton) {
              sortButton.click();
            }

            const container = document.querySelector(
              ".wizzy-search-wrapper .wizzy-search-results-wrapper .wizzy-search-results-container .wizzy-search-filters-top .search-filters-top-wrapper .wizzy-search-sort-wrapper .wizzy-sort-container .wizzy-common-select-wrapper .wizzy-common-select-container .wizzy-common-select-options"
            );
            container.style.setProperty("display", "none", "important");
          });
        }
      }

      const original = document.querySelector(
        ".wizzy-filters-facet-block.facet-block-sizes"
      );

      if (original) {
        const targetContainer = document.querySelector(
          ".wizzy-search-filters-top .search-filters-top-wrapper .wizzy-search-filters-list-top"
        );

        if (targetContainer) {
          const existingClone = targetContainer.querySelector(
            ".wizzy-filters-facet-block.facet-block-sizes.facet-block-top"
          );

          if (!existingClone) {
            const clone = original.cloneNode(true); // true for deep clone
            clone.classList.remove("facet-block-left", "collapsed");
            clone.classList.add("facet-block-top");

            targetContainer.appendChild(clone);
          }
        }
      }
      var filterPanel = document.querySelectorAll(
        ".wizzy-search-wrapper .wizzy-search-filters-left .wizzy-filters-facet-block .wizzy-facet-head"
      );

      filterPanel.forEach((facet) => {
        facet.addEventListener("click", function (e) {
          let currentFilter = this.closest(".wizzy-filters-facet-block");
          const isActive = currentFilter.classList.contains("collapsed");

          setTimeout(() => {
            filterPanel.forEach((h) => {
              let filter = h.closest(".wizzy-filters-facet-block");
              if (filter !== currentFilter) {
                filter.classList.add("collapsed");
              }
            });

            if (isActive) {
              currentFilter.classList.remove("collapsed");
            } else {
              currentFilter.classList.add("collapsed");
            }
          }, 100);
        });
      });
      // console.log("in view rendered");
      let ranges = document.querySelectorAll(
        ".wizzy-facet-list-item.facet-rangeList-item .wizzy-facet-list-item-count"
      );
      ranges.forEach((range) => {
        if (range.textContent.trim() === "(0)") {
          range.parentElement.remove(); // remove the parent element from the DOM
        }
      });

      const selectedList = document.querySelector(".wizzy-selected-facet-list");
      const targetDiv1 = document.querySelector(".wizzy-facet-list-block"); // Replace if needed
      const targetDiv2 = document.querySelectorAll(".wizzy-facet-body"); // Replace if needed
      let title = document.querySelector(".applied-filters-header");
      if (selectedList && selectedList.querySelectorAll("li").length > 0) {
        // console.log("Inside divs");
        targetDiv1?.classList.add("with-selected-filters");
        targetDiv2.forEach((d) => {
          d?.classList.add("with-selected-filters");
        });
        title?.classList.remove("remove");
      } else {
        // console.log("inside remove");
        // console.log("No selected filters");
        targetDiv1?.classList.remove("with-selected-filters");
        targetDiv2.forEach((d) => {
          d?.classList.remove("with-selected-filters");
        });
        // console.log(title);
        title?.classList.add("remove");
        // console.log("Removed title", title);
      }
      document
        .querySelectorAll(".wizzy-grid-filters-box")
        .forEach((filterBox) => {
          const facetList = filterBox.querySelector(".wizzy-facet-list");
          const leftButton = filterBox.querySelector(".scroll-btn.left");
          const rightButton = filterBox.querySelector(".scroll-btn.right");

          if (!facetList || !leftButton || !rightButton) return;

          leftButton.addEventListener("click", () => {
            facetList.scrollBy({ left: -200, behavior: "smooth" });
          });

          rightButton.addEventListener("click", () => {
            facetList.scrollBy({ left: 200, behavior: "smooth" });
          });
        });

      const priceElements = document.querySelectorAll('.price-item--regular');
      priceElements.forEach((el) => {
        el.textContent = el.textContent.replace(/\.00\b/, '');
      });
      return data;
    }
  );
}


let searchbtn = document.querySelector(".search_main_new");
searchbtn.addEventListener("click", function () {
  let searchBar = document.querySelector(".search__input");
  if (searchBar) {
    searchBar.click();
  }
});
